export default __webpack_public_path__ + "static/media/rb3.7046f802.jpg";